import { render, staticRenderFns } from "./pointOfInterest.vue?vue&type=template&id=7ea44488"
import script from "./pointOfInterest.vue?vue&type=script&lang=ts"
export * from "./pointOfInterest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports